import { fetchData } from './handleApiRequest'
import { getLocalisationCookie } from '../LocalisationCookie'

export function handleAutocompleteRequest(api, query, successCb, errorCb) {
  let url = api.replace(/%QUERY%/g, encodeURIComponent(query))

  const cookie = getLocalisationCookie()
  if (cookie) {
    url = url.replace(/%CLIENT_UID%/g, cookie.client?.id)
  } else {
    url = url.replace(/%CLIENT_UID%/g, 0)
  }

  fetchData({ url })
    .then((response) => {
      const { results } = response
      successCb(results)
    })
    .catch((error) => {
      if (errorCb) {
        errorCb(error)
      }
    })
}
